var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"9d06f2b0"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/promotion_src/public/optimus-eechic-online/9d06f2b0";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from "@sentry/nextjs";
import {
	ReportingObserver as ReportingObserverIntegration,
	Dedupe as DedupeIntegration,
} from "@sentry/integrations";

const dsn = "https://96b302e173f2439dad488ead6dd27ad5@sentry.lightinthebox.com/8";

const integrations = [
	new ReportingObserverIntegration({
		// deprecation：监听过时的api
		// intervention: 浏览器对网页做的干预
		// crash: 浏览器崩溃时的行为
		types: ["deprecation"],
	}),
	new Sentry.BrowserTracing({
		beforeNavigate: (context) => {
			return {
				...context,
				name: replacePathname(location.pathname),
			};
		},
	}),
	// 错误去重
	new DedupeIntegration(),
];

function replacePathname(pathname = "") {
	if (pathname.match(/\/active\//)) {
		return "/active";
	}
	return pathname;
}

Sentry.init({
	serverName: "OPTIMUS_SUNFLOWER",
	integrations,
	dsn,
	// Note: if you want to override the automatic release value, do not set a
	// `release` value here - use the environment variable `SENTRY_RELEASE`, so
	// that it will also get attached to your source maps
	// release: SENTRY_RELEASE ? SENTRY_RELEASE.id : NEXT_PUBLIC_COMMIT_SHA,
	tracesSampler: () => {
		return 1;
	},
	environment: NEXT_ENV_ENVIRONMENT,
	ignoreErrors: [
		"getAttribute",
		// Heavy Ad Intervention
		"Ad was removed",
	],
	denyUrls: [
		"https://ctrlitb.rightinthebox.com/ctr_tracking.php",
		"https://bat.bing.com/bat.js",
		"https://c.go-mpulse.net",
		"https://s.go-mpulse.net/boomerang/M9CN2-VCB4C-NSL5N-AT24S-PXY2W",
		"https://connect.facebook.net",
		"https://www.google-analytics.com/analytics.js",
	],
	enableTracing: true,
	// This option is required for capturing headers and cookies.
	sendDefaultPii: true,
});
